<template>
  <div v-outside-click="hideContextMenu" style="position: relative">
    <sub-context :data="data" :depth="0" @hide-subcontext-menu="hideContextMenu" />
  </div>
</template>
<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../../utils/constants";
import SubContext from "../../../redZone/content/SubContext.vue";
import DesignerMixin from "../../DesignerMixin";
export default {
  components: { SubContext },
  mixins: [DesignerMixin],
  props: ["styleItem"],
  data() {
    return {
      data: [
        {
          id: 1,
          icon: "",
          title: this.$t("contextMenu.apply"),
          func: this.selectStyle,
        },
        {
          id: 2,
          icon: "",
          title: this.$t("contextMenu.modify"),
          func: this.modifyStyle,
        },
        {
          id: 3,
          icon: "",
          title: this.$t("contextMenu.duplicate"),
          func: this.duplicateStyle,
        },
        {
          id: 4,
          icon: "",
          title: this.$t("contextMenu.delete"),
          func: this.deleteStyle,
        },
      ],
    };
  },
  computed: {
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.SidebarContextMenu);
  },
  beforeUnmount() {
    this.$store.dispatch("setScope", HotkeyScopes.CellContextMenu);
  },
  methods: {
    selectStyle() {
      this.$store.dispatch("rangeStyle/updateRangeStyle", { data: this.styleItem });
      this.$store.dispatch("preferences/toggleShowCutomStyles", false);
      this.hideContextMenu();
    },
    hideContextMenu() {
      this.$store.dispatch("resetActiveContextMenu");
      this.$store.dispatch("setScope", HotkeyScopes.CellContextMenu);
    },
    modifyStyle() {
      this.$store.dispatch("preferences/setEditableStyleId", this.styleItem.id);
      this.hideContextMenu();
    },
    duplicateStyle() {
      this.$store.dispatch("preferences/duplicateStyle", { id: this.styleItem.id });
      this.hideContextMenu();
    },
    deleteStyle() {
      this.$store.dispatch("preferences/deleteStyle", { id: this.styleItem.id });
    },
  },
};
</script>
